module.exports = __webpack_public_path__ + "img/pay_card2.b70a29b7.svg";